// Git info injected by vite.config.ts define
const gitInfo = {
  branch: import.meta.env.VITE_GIT_BRANCH || 'unknown',
  commit: {
    date: import.meta.env.VITE_GIT_COMMIT_DATE || 'unknown',
    hash: import.meta.env.VITE_GIT_COMMIT_HASH || 'unknown',
    message: import.meta.env.VITE_GIT_COMMIT_MESSAGE || '',
    shortHash: import.meta.env.VITE_GIT_COMMIT_SHORT_HASH || 'unknown',
  },
  tags: [] as string[],
}

export default gitInfo
